import script from "./ToggleEditMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleEditMode.vue?vue&type=script&lang=ts&setup=true"

import "./ToggleEditMode.vue?vue&type=style&index=0&id=c48737a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c48737a8"]])

export default __exports__